<template>
  <div class="sidebar">

<div class="SideMenuborder">
</div>

    <img  :src="moodIcon" alt=""  style="width:75%;margin:auto auto 20px auto;display:flex;">
  

    <div class="sideContainer" >




      <div class="overlayContainer">
<p class="MenuTitle" style="  font-size:21px;" >Menu</p>
  <router-link
      v-if="permissions.includes('viewAny organization')"
      @click="checkDataHandler($event, 'organizations')"
      @mouseenter="hoveredTap = 'organizations'"
      @mouseleave="hoveredTap = null"
      :to="setDataFlag ? '#' : '/organizations'"
      :class="{ active: activeTap === 'organizations' }"
      class="nav-link"
    >
      <!--            <img src="../../assets/images/organization.png"  style="margin:auto;" alt="">-->

      <div class="link-container gap-3 sidebar-icon">
        <span class="">
          <img
            :src="getActionIcon('organizations', activeTap === 'organizations')"
            class="menu-image"
          >
        </span>
        <span class="d-none d-sm-inline" style="font-size: 15px"
          >Organizations</span
        >
      </div>
    </router-link>
    <router-link
      v-if="role === 'super_admin'"
      @click="checkDataHandler($event, 'roles')"
      @mouseenter="hoveredTap = 'roles'"            
      @mouseleave="hoveredTap = null"
      :to="setDataFlag ? '#' : '/roles'"
      :class="{ active: activeTap === 'roles' }"
      class="nav-link"
    >
      <div class="link-container gap-3 sidebar-icon">
        <span class="">
          <img :src="getActionIcon('roles', activeTap === 'roles')" class="menu-image">
        </span>
        <span class="d-none d-sm-inline" style="font-size: 15px">Roles</span>
      </div>
    </router-link>
    <router-link
      v-if="role === 'super_admin'"
      @click="checkDataHandler($event, 'super/users')"
      @mouseenter="hoveredTap = 'users'"
      @mouseleave="hoveredTap = null"
      :to="setDataFlag ? '#' : '/super/users'"
      :class="{ active: activeTap === 'super-users' }"
      class="nav-link"
    >
      <div class="link-container gap-3 sidebar-icon">
        <span class="">
          <img :src="getActionIcon('users', activeTap === 'super-users')" class="menu-image">
        </span>
        <span class="d-none d-sm-inline" style="font-size: 15px">Users</span>
      </div>
    </router-link>
    <router-link
      v-if="permissions.includes('viewAny template')"
      @click="checkDataHandler($event, 'templates')"
      @mouseenter="hoveredTap = 'templates'"
      @mouseleave="hoveredTap = null"
      :to="setDataFlag ? '#' : '/templates'"
      :class="{ active: activeTap === 'templates' }"
      class="nav-link"
    >
      <!--            <img src="../../assets/images/templateImage.png" width="20" alt=""> <span-->
      <!--                class="ms-1 d-none d-sm-inline" style="font-size:15px">Templates</span>-->

      <div class="link-container gap-3 sidebar-icon">
        <span class="">
          <img :src="getActionIcon('templates', activeTap === 'templates')" class="menu-image">
        </span>
        <span class="d-none d-sm-inline" style="font-size: 15px"
          >Templates</span
        >
      </div>
    </router-link>

    <router-link
      v-if="permissions.includes('viewAny competition') && role !== 'user'"
      @click="checkDataHandler($event, 'competitions')"
      @mouseenter="hoveredTap = 'competitions'"
      @mouseleave="hoveredTap = null"
      :to="setDataFlag || setAnswersFlag ? '#' : '/competitions'"
      :class="{ active: activeTap === 'competition' }"
      class="nav-link"
    >
      <!--            <img src="../../assets/images/trophy.png" width="20" alt=""> <span class="ms-1 d-none d-sm-inline"-->
      <!--                                                                               style="font-size:15px">Competitions</span>-->

      <div class="link-container gap-3 sidebar-icon">
        <span class="">
          <img :src="getActionIcon('competitions', activeTap === 'competitions')" class="menu-image">
        </span>
        <span class="d-none d-sm-inline" style="font-size: 15px"
          >Competitions</span
        >
      </div>
    </router-link>

    <router-link
      v-else-if="permissions.includes('viewAny competition') && role === 'user'"
      @click="checkDataHandler($event, 'user-competitions')"
      :to="setDataFlag || setAnswersFlag ? '#' : '/user-competitions'"
      :class="{ active: activeTap === 'competition' }"
      class="nav-link"
    >
      <div class="d-flex gap-3 sidebar-icon">
        <span class="">
          <font-awesome-icon class="" :icon="['fas', 'trophy']" size="sm" />
        </span>
        <span class="d-none d-sm-inline" style="font-size: 15px"
          >Competitions</span
        >
      </div>
    </router-link>

    <div v-else></div>

    <router-link
      v-if="permissions.includes('viewAny training') && role !== 'user'"
      @click="checkDataHandler($event, 'trainings')"
      @mouseenter="hoveredTap = 'trainings'"
      @mouseleave="hoveredTap = null"
      :to="setDataFlag || setAnswersFlag ? '#' : '/trainings'"
      :class="{ active: activeTap === 'training' }"
      class="nav-link"
    >
      <!--            <img src="../../assets/images/training.png" width="20" alt=""> <span class="ms-1 d-none d-sm-inline"-->
      <!--                                                                                 style="font-size:15px">Training</span>-->

      <div class="link-container gap-3 sidebar-icon">
        <span class="">
          <img :src="getActionIcon('trainings', activeTap === 'trainings')" class="menu-image">
        </span>
        <span class="d-none d-sm-inline" style="font-size: 15px"
          >Trainings
        </span>
      </div>
    </router-link>

    <router-link
      v-else-if="permissions.includes('viewAny training') && role === 'user'"
      @click="checkDataHandler($event, 'user-trainings')"
      :to="setDataFlag || setAnswersFlag ? '#' : '/user-trainings'"
      :class="{ active: activeTap === 'training' }"
      class="nav-link"
    >
      <div class="link-container gap-3 sidebar-icon">
        <span class="">
          <font-awesome-icon class="" :icon="['fas', 'brain']" size="sm" />
        </span>
        <span class="d-none d-sm-inline" style="font-size: 15px"
          >Trainings</span
        >
      </div>
    </router-link>

      <div v-else></div>





          <router-link
      v-if="permissions.includes('viewAny userscore')"
      @click="checkDataHandler($event, 'results')"
      @mouseenter="hoveredTap = 'results'"
      @mouseleave="hoveredTap = null"
      :to="setDataFlag ? '#' : '/results'"
      :class="{ active: activeTap === 'results' }"
      class="nav-link"
    >
      <!--            <img src="../../assets/images/results.png" width="20" alt=""> <span class="ms-1 d-none d-sm-inline"-->
      <!--                                                                                style="font-size:15px">Results</span>-->

      <div class="link-container gap-3 sidebar-icon">
        <span class="">
          <img :src="getActionIcon('results', activeTap === 'results')" class="menu-image">
        </span>
        <span class="d-none d-sm-inline" style="font-size: 15px">Results</span>
      </div>
    </router-link>

    <router-link
      v-if="permissions.includes('viewAny score')"
      @click="checkDataHandler($event, 'results')"
      :to="setDataFlag ? '#' : '/user-score'"
      :class="{ active: activeTap === 'score' }"
      class="nav-link"
    >
      <!--            <img src="../../assets/images/results.png" width="20" alt=""> <span class="ms-1 d-none d-sm-inline"-->
      <!--                                                                                style="font-size:15px">Score</span>-->

      <div class="link-container gap-3 sidebar-icon">
        <span class="">
          <font-awesome-icon
            class=""
            :icon="['fas', 'clipboard-list']"
            size="sm"
          />
        </span>
        <span class="d-none d-sm-inline" style="font-size: 15px">Scores</span>
      </div>
    </router-link>

    <router-link
      v-if="permissions.includes('viewAny setting')"
      @click="checkDataHandler($event, 'settings/user')"
      @mouseenter="hoveredTap = 'settings'"
      @mouseleave="hoveredTap = null"
      :to="setDataFlag ? '#' : '/settings/roles'"
      :class="{ active: activeTap === 'settings' }"
      class="nav-link"
    >
      <!--            <img src="../../assets/images/settings.png" width="20" alt="">-->
      <!--            <span class="ms-1 d-none d-sm-inline"-->
      <!--                                                                                 style="font-size:15px">Settings</span>-->

      <div class="link-container gap-3 sidebar-icon">
        <span class="">
          <img :src="getActionIcon('settings', activeTap === 'settings')" class="menu-image">
        </span>
        <span class="d-none d-sm-inline" style="font-size: 15px">Settings</span>
      </div>
    </router-link>

    <router-link
      v-if="permissions.includes('viewAny entity')"
      @click="checkDataHandler($event, 'settings/entities')"
      @mouseenter="hoveredTap = 'entities'"
      @mouseleave="hoveredTap = null"
      :to="setDataFlag ? '#' : '/settings/entities'"
      :class="{ active: activeTap === 'settings-entities' }"
      class="nav-link"
    >
      <!--            <img src="../../assets/images/playlist_add_black.svg" width="20" alt=""> <span-->
      <!--                class="ms-1 d-none d-sm-inline" style="font-size:15px">Entities</span>-->

      <div class="link-container gap-3 sidebar-icon">
        <span class="">
          <img :src="getActionIcon('entities', activeTap === 'settings-entities')" class="menu-image">
        </span>
        <span class="d-none d-sm-inline" style="font-size: 15px">Entities</span>
      </div>
    </router-link>
    <!-- <a v-if="role === 'admin'" :href="reportsUrl" class="nav-link">
      <div class="link-container gap-2 sidebar-icon">
        <span class="">
          <svg
            stroke="currentColor"
            fill="none"
            stroke-width="2"
            viewBox="0 0 24 24"
            stroke-linecap="round"
            stroke-linejoin="round"
            xmlns="http://www.w3.org/2000/svg"
            height="20"
            width="20"
          >
            <path
              d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
            ></path>
            <path
              d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
            ></path>
            <path d="M9 17v-5"></path>
            <path d="M12 17v-1"></path>
            <path d="M15 17v-3"></path>
          </svg>
        </span>
        <span class="d-none d-sm-inline" style="font-size: 15px">Reports</span>
      </div>
    </a> -->

    </div>
    </div>









 <img class="sideMenuFooterImg" src="../../assets/images/Group_175874.png" alt=""   >



<!-- 
    <div class="storage_wrapper" v-if="role === 'admin'">
      <div class="d-flex justify-content-between align-items-center">
        <span class="d-none d-sm-inline storage">Storage</span>
        <span class="d-none d-sm-inline storage_value">
          {{ this.storage }}%</span
        >
      </div>
      <div class="shell">
        <div class="bar" :style="{ width: this.storage + '%',background:this.background }"></div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { computed, getCurrentInstance } from "vue";
import { mapGetters } from "vuex";
import repository from "../../api-services/repository";

import lightIcon from '@/assets/images/Group_s175989.png'
import darkIcon  from '@/assets/images/Group_175873.png'



export default {
  name: "sidebar-vue",
  data() {
    return {
      hoveredTap: null,
      permissions: [],
      role: "",
      isActive: false,
      setDataFlag: computed(() => this.$store.state.settings.setDataFlag),
      setAnswersFlag: computed(() => this.$store.state.settings.setAnswersFlag),
      active: computed(() => this.$store.state.settings.activeTap),
      lightMode: null,
      background:'#2DC937',
      storage: 0,
      reportsUrl: computed(
        () =>
          `${process.env.VUE_APP_REPORTS_URL}?secret=${
            JSON.parse(sessionStorage.getItem("user")).token
          }&&theme=${this.$store.state.settings.isLightMood ? "light" : "dark"}`
      ),
    };
  },
  async mounted() {
    this.lightMood = this.$store.state.settings.isLightMood;
    let urlNow = this.$router.currentRoute.value;
    let substring = "view-trainings";

    this.permissions = this.$store.state.auth.permissions;
    this.role = this.$store.state.auth.user.data.role[0];

    let urlSplit = this.$router.currentRoute.value;
    if (
      urlSplit.fullPath === "/settings/teams" ||
      urlSplit.fullPath === "/settings/user"
    ) {
      this.isActive = true;
    } else if (urlNow.fullPath.includes(substring)) {
      this.isActive = true;
    } else {
      this.isActive = false;
    }

    if (this.permissions.includes("viewAny template")) {
      try {
        let resData = await repository.getAvailableStorage();
        if(resData.data.percentage > 90){ this.background = "#CC3232"}
        else if(resData.data.percentage <= 90 && resData.data.percentage > 70){this.background="#DB7B2B"}
        this.storage = resData?.data?.percentage;
      } catch (error) {
        console.log("error", error);
      }
    }
  },
  methods: {
    async checkDataHandler(e, currentRoute) {
      let setDataFlag = this.$store.state.settings.setDataFlag;
      let setAnswersFlag = this.$store.state.settings.setAnswersFlag;
      if (process.env.VUE_ENV === "development")
        console.log({ setAnswersFlag });
      await this.$store.dispatch("currentRoute", currentRoute);
      if (setAnswersFlag) {
        await this.$store.dispatch("setConfirmModal", true);
        await this.$store.dispatch(
          "setConfirmMessage",
          "Are you sure you want to exit and save all answers?"
        );
      } else if (setDataFlag) {
        if (process.env.VUE_ENV === "development") console.log("error");
        await this.$store.dispatch("setConfirmModal", true);
        await this.$store.dispatch(
          "setConfirmMessage",
          "Are you sure you want to go back and remove all data?"
        );
      } else {
        if (process.env.VUE_ENV === "development") console.log("ok");
        await this.$store.dispatch("setDataFlag", false);
        await this.$store.dispatch("setConfirmModal", false);
      }
    },
    getActionIcon(iconName, isActive) {
    try {
      if (this.isLightMood || isActive || this.hoveredTap === iconName) {
        return require(`../../assets/images/${iconName}-light.png`);
      } else{
        return require(`../../assets/images/${iconName}.png`);
      }
    } catch (e) {
      return require(`../../assets/images/${iconName}.png`);
    }
  },  
  },
  computed: {
    ...mapGetters(["activeTap"]),  isLightMood() {
    return this.$store.state.settings.isLightMood;
  },

  // This computes the correct icon based on store state
  moodIcon() {
    return this.isLightMood ? lightIcon : darkIcon;
  }
  },
  watch: {
    activeTap(newValue, oldValue) {
      return newValue;
    },
  },
};

</script>

<style scoped>
.storage_wrapper {
  margin: 1em auto 0;
}
.storage_wrapper > div {
  width: 90%;
}
.storage {
  font-weight: 600;
  padding-left: 5%;
}
.storage_value {
  font-weight: 400;
  font-size: 14px;
}
.shell {
  height: 10px;
  width: 90%;
  margin: 0.3em auto;
  border: 1px solid #aaa;
  border-radius: 13px;
}

.bar {
  background: var(--btn-bg-color);
  height: 8px;
  width: 15px;
  border-radius: 9px;
}
.bar span {
  float: right;
  padding: 4px 5px;
  color: #fff;
  font-size: 0.7em;
}

.link-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.sidebar-icon {
  font-weight: 600;
  font-size: 18px;
  /*color: var(--link-icon-color);*/
}
.sidebar {
  width: 250px !important;
  margin: 0;
  padding: 105px 0 0 0 !important;
  background-color: var(--side-menu-color);
  height: 100%;
  overflow: auto;  
  border:0px;
  border-left:12px;
  border-color:#DBE2EA;
  border-style:solid;
}

.sidebar-icon{
  width:auto;
}
.menu-image{
  width:20px;
}
 
.SideMenuborder{
  position:absolute;
  height:415px;
  width:15px;
  background-color:#E95626;
  left:250px;
  border-radius:0px 10px 10px 0;
  top:167px
}
.overlayContainer{
  position: relative;
  z-index: 10 !important;
}
.sidebar a {
  display: flex;

  color: var(--main-bg2-color);
  padding: 8px 6px 8px 14px;
  text-decoration: none;
  
}
.sideMenuFooterImg{
position:absolute;
bottom:-6px;
left:2px;
width:236px;
}
.sidebar a.active {
  background-color: #E95626;
  color: var(--link-text-color);
border-radius:7px;
}
.sideContainer{
width:80%;
  margin-left:35px;
  
}
.sidebar a:hover:not(.active) {
  background-color: var(--link-active-color);
  color: var(--link-text-color);
  border-right: 4px solid var(--link-active-border-color);
}
.MenuTitle{
  color: var(--secondary-title-color);
  font-weight:bold !important;
}
@media(max-width:1280px){
  .sidebar{
    width:200px !important;
    padding: 85px 0 0 0 !important;
  }
  .sideContainer{
    margin-left:22px;
    width:86%
  }
  .sidebar-icon{
    gap:0.5rem !important;
  }
  .SideMenuborder{
    width:11px;
    left:200px;
    height: 350px;
    top: 140px;
  }
  .sideMenuFooterImg{
    width:200px;
    left:-6px ;
    bottom: -10px;
  }

}

</style>